export default __webpack_public_path__ + "static/media/milo.1e616143.jpeg";